module.exports = __webpack_public_path__ + "static/nutrition_pie_chart_layout-2034e39b3a194850d721be98a8e4dde4.png";